var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45455 0C4.00791 0 2.62053 0.574674 1.5976 1.5976C0.574674 2.62053 0 4.00791 0 5.45455V24.5455C0 25.9921 0.574674 27.3795 1.5976 28.4024C2.62053 29.4253 4.00791 30 5.45455 30H24.5455C25.9921 30 27.3795 29.4253 28.4024 28.4024C29.4253 27.3795 30 25.9921 30 24.5455V5.45455C30 4.00791 29.4253 2.62053 28.4024 1.5976C27.3795 0.574674 25.9921 0 24.5455 0H5.45455ZM15.4636 4.77273H18.7186C18.7186 6.95455 20.5623 9.42273 23.3686 9.42273V12.6764C21.4364 12.5427 19.785 12.2264 18.7186 11.2814V19.6486C18.7186 21.9736 16.8805 25.2273 12.6764 25.2273C7.54091 25.2273 6.63273 20.5773 6.63273 19.1836C6.63273 17.79 7.45091 13.14 13.14 13.14V16.395C11.6523 16.08 9.88636 17.3236 9.88636 19.1836C9.88636 21.5086 11.2814 21.9736 12.6764 21.9736C14.0714 21.9736 15.465 20.5786 15.465 19.1836L15.4636 4.77273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTic);
export default __webpack_public_path__ + "static/media/ic_tic.e7bbcf4442a02d6246e6cf5ba81e2d53.svg";
export { ForwardRef as ReactComponent };